// extracted by mini-css-extract-plugin
module.exports = {"tabs":"EditProduct_tabs__1Dela"};